import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { SesionActiva } from '../config/Sesion'

export const PrivateRoute = (isAuthenticated) => {
    return SesionActiva() ? <Outlet/> : <Navigate to="/login" />
}